<template>
  <main class="flex flex-col gap-8 py-8">
    <h3>
      {{ "Gestão de Turmas" }}
    </h3>
    <TabView
      class="!pb-0 custom-tabsForum"
      @tab-change="changeTab"
      :lazy="true"
      v-if="user?.role === 'TEACHER'"
    >
      <TabPanel v-for="(tab, i) in tabs" :key="i">
        <template #header>
          <div class="w-full mx-8 text-center">
            <span>{{ tab.title }}</span>
          </div>
        </template>
        <component :is="tab.component" class="mt-8"></component>
      </TabPanel>
    </TabView>
    <Classes v-else />
  </main>
</template>
<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
import { useAuthStore } from "@/store/auth";
const Activities = defineAsyncComponent(
  () => import("./Activities/activities.vue")
);
const Classes = defineAsyncComponent(() => import("./Content/classes.vue"));
export default defineComponent({
  components: { Classes, Activities },
  computed: {
    tabs() {
      return [
        {
          title: this.$t("labels.generic", {
            en: "Classes",
            pt: "Turmas",
          }),
          component: Classes,
        },
        {
          title: this.$t("labels.generic", {
            en: "Activities",
            pt: "Atividades",
          }),
          component: Activities,
        },
      ];
    },
    user() {
      return useAuthStore?.data;
    },
  },

  setup() {
    function changeTab(event: any) {
      console.log(event, "event");
    }
    return {
      changeTab,
    };
  },
});
</script>
